import React from 'react';
import { cn } from '../ui/cn';

/**
 * Compact page header: title + one-line subtitle on the left, actions on the right.
 */
const PageHeader = ({ title, subtitle, children, className }) => (
  <header className={cn('flex items-start justify-between gap-3 mb-4 lg:mb-6', className)}>
    <div className="min-w-0">
      <h1 className="text-[26px] lg:text-[30px] font-bold tracking-tight leading-tight text-primary truncate">{title}</h1>
      {subtitle && <p className="text-sm text-secondary mt-0.5 truncate">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-shrink-0">{children}</div>}
  </header>
);

export default PageHeader;
